<template>
  <div>
    <BankReconciliationModal v-if="selectedTransaction" :selectedTransaction="selectedTransaction" @cancel="onModalClose" />

    <div class="bank-wrapper content--inner">
      <BankTransactionsSidebar />
      <div class="bank-table">
        <FilterBar 
          cookieName="BankFilterOptionsVue" 
          class="no-totals"
          filterBarType="bank" 
          @change="filtersChanged" 
          :mainFilters="['SearchFilter', 'DateRangeFilter', 'TransactionTypeFilter', 'TransactionAmountFilter']"
        />
        <BankTransactionsTable v-if="selectedAccount" @row-clicked="selectTransaction" @refresh-transactions="$emit('update-transactions', false)" ref="BankTransactionsTable" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FilterBar from '@/components/list_filters/FilterBar';
import GekkoButton from "@/components/GekkoButton";
import BankTransactionsSidebar from "@/components/bank/ui/BankTransactionsSidebar";
import BankReconciliationModal from "@/components/bank/ui/BankReconciliationModal";
import BankTransactionsTable from "@/components/bank/ui/BankTransactionsTable";

export default {
  name: 'BankTransactions',
  components: {
    FilterBar,
    GekkoButton,
    BankTransactionsSidebar,
    BankReconciliationModal,
    BankTransactionsTable
  },
  data () {
    return {
      selectedTransaction: null
    }
  },
  computed: {
    ...mapGetters ({ 
      getBankAccount: "bankStore/getBankAccount",
      selectedAccount: "bankStore/getSelectedAccount"
    })
  },
  created () {
  },
  methods: {
    filtersChanged () {
      if (this.$refs['BankTransactionsTable']) this.$refs['BankTransactionsTable'].getTransactions();
    },
    selectTransaction (transaction) {
      this.selectedTransaction = transaction
    },
    onModalClose () {
      this.selectedTransaction = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .bank-wrapper {
    display: flex;
    flex: 1;
    .bank-table {
      padding: 1rem;
      flex: 1;
      .filterbar {
        margin-bottom: 0.5rem;
      }
    }
    @media (max-width: '768px') {
      flex-direction: column;
    }
  }
</style>
